"use strict";
import { config } from "config";
import { isBetaEnv, isDevEnv, isPlaywrightEnv, isTestEnv } from "utilities/src/environment/env";
import { isAndroid, isExtension, isInterface, isMobileApp } from "utilities/src/platform";
var TrafficFlows = /* @__PURE__ */ ((TrafficFlows2) => {
  TrafficFlows2["GraphQL"] = "graphql";
  TrafficFlows2["Metrics"] = "metrics";
  TrafficFlows2["Gating"] = "gating";
  TrafficFlows2["TradingApi"] = "trading-api-labs";
  TrafficFlows2["Unitags"] = "unitags";
  TrafficFlows2["FOR"] = "for";
  TrafficFlows2["Scantastic"] = "scantastic";
  return TrafficFlows2;
})(TrafficFlows || {});
const FLOWS_USING_BETA = ["for" /* FOR */];
const isDevOrBeta = isPlaywrightEnv() ? false : isDevEnv() || isBetaEnv();
export const UNISWAP_WEB_HOSTNAME = "app.topazdex.com";
const EMBEDDED_WALLET_HOSTNAME = isPlaywrightEnv() || isDevEnv() ? "staging.ew.unihq.org" : UNISWAP_WEB_HOSTNAME;
export const UNISWAP_WEB_URL = `https://${UNISWAP_WEB_HOSTNAME}`;
export const UNISWAP_APP_URL = "https://www.topazdex.com/app";
export const UNISWAP_MOBILE_REDIRECT_URL = "https://www.topazdex.com";
const helpUrl = "https://www.topazdex.com/docs";
const tradingApiVersionPrefix = config.tradingApiWebTestEnv === "true" ? "" : "/v1";
export const uniswapUrls = {
  // Help and web articles/items
  helpUrl,
  helpRequestUrl: `${helpUrl}`,
  helpArticleUrls: {
    acrossRoutingInfo: `${helpUrl}`,
    approvalsExplainer: `${helpUrl}`,
    batchedSwaps: `${helpUrl}`,
    batchedSwapsFailure: `${helpUrl}`,
    batchedSwapsReview: `${helpUrl}`,
    cexTransferKorea: `${helpUrl}`,
    contractAddressExplainer: `${helpUrl}`,
    extensionHelp: `${helpUrl}`,
    extensionDappTroubleshooting: `${helpUrl}`,
    feeOnTransferHelp: `${helpUrl}`,
    howToSwapTokens: `${helpUrl}`,
    hiddenTokenInfo: `${helpUrl}`,
    hiddenNFTInfo: `${helpUrl}`,
    impermanentLoss: `${helpUrl}`,
    limitsFailure: `${helpUrl}`,
    limitsInfo: `${helpUrl}`,
    limitsNetworkSupport: `${helpUrl}`,
    lpIncentiveInfo: `${helpUrl}`,
    fiatOnRampHelp: `${helpUrl}`,
    fiatOffRampHelp: `${helpUrl}`,
    transferCryptoHelp: `${helpUrl}`,
    mismatchedImports: `${helpUrl}`,
    mobileWalletHelp: `${helpUrl}`,
    moonpayRegionalAvailability: `${helpUrl}`,
    multichainDelegation: `${helpUrl}`,
    networkFeeInfo: `${helpUrl}`,
    poolOutOfSync: `${helpUrl}`,
    positionsLearnMore: `${helpUrl}`,
    priceImpact: `${helpUrl}`,
    providingLiquidityInfo: `${helpUrl}`,
    recoveryPhraseHowToImport: `${helpUrl}`,
    recoveryPhraseHowToFind: `${helpUrl}`,
    recoveryPhraseForgotten: `${helpUrl}`,
    revokeExplainer: `${helpUrl}`,
    supportedNetworks: `${helpUrl}`,
    swapFeeInfo: `${helpUrl}`,
    passkeysInfo: `${helpUrl}`,
    smartWalletDelegation: `${helpUrl}`,
    swapProtection: `${helpUrl}`,
    swapSlippage: `${helpUrl}`,
    tokenWarning: `${helpUrl}`,
    transactionFailure: `${helpUrl}`,
    uniswapXInfo: `${helpUrl}`,
    uniswapXFailure: `${helpUrl}`,
    unsupportedTokenPolicy: `${helpUrl}`,
    addingV4Hooks: `${helpUrl}`,
    routingSettings: `${helpUrl}`,
    v4HooksInfo: `${helpUrl}`,
    walletSecurityMeasures: `${helpUrl}`,
    wethExplainer: `${helpUrl}`
  },
  termsOfServiceUrl: `${helpUrl}`,
  privacyPolicyUrl: `${helpUrl}`,
  chromeExtension: `${helpUrl}`,
  // Download links
  appStoreDownloadUrl: "https://apps.apple.com/us/app/uniswap-crypto-nft-wallet/id6443944476",
  playStoreDownloadUrl: "https://play.google.com/store/apps/details?id=com.uniswap.mobile&pcampaignid=web_share",
  // Core API Urls
  apiOrigin: "https://api.uniswap.org",
  apiBaseUrl: config.apiBaseUrlOverride || getCloudflareApiBaseUrl(),
  apiBaseUrlV2: config.apiBaseUrlV2Override || `${getCloudflareApiBaseUrl()}/v2`,
  graphQLUrl: config.graphqlUrlOverride || `${getCloudflareApiBaseUrl("graphql" /* GraphQL */)}/v1/graphql`,
  // Proxies
  amplitudeProxyUrl: config.amplitudeProxyUrlOverride || `${getCloudflareApiBaseUrl("metrics" /* Metrics */)}/v1/amplitude-proxy`,
  statsigProxyUrl: config.statsigProxyUrlOverride || `${getCloudflareApiBaseUrl("gating" /* Gating */)}/v1/statsig-proxy`,
  // Feature service URL's
  unitagsApiUrl: config.unitagsApiUrlOverride || `${getCloudflareApiBaseUrl("unitags" /* Unitags */)}/v2/unitags`,
  scantasticApiUrl: config.scantasticApiUrlOverride || `${getCloudflareApiBaseUrl("scantastic" /* Scantastic */)}/v2/scantastic`,
  forApiUrl: config.forApiUrlOverride || `${getCloudflareApiBaseUrl("for" /* FOR */)}/v2/FOR.v1.FORService`,
  tradingApiUrl: config.tradingApiUrlOverride || getCloudflareApiBaseUrl("trading-api-labs" /* TradingApi */),
  // Merkl Docs for LP Incentives
  merklDocsUrl: "https://docs.merkl.xyz/earn-with-merkl/faq-earn#how-are-aprs-calculated",
  // Embedded Wallet URL's
  // Totally fine that these are public
  evervaultDevUrl: "https://embedded-wallet-dev.app-907329d19a06.enclave.evervault.com",
  evervaultStagingUrl: "https://embedded-wallet-staging.app-907329d19a06.enclave.evervault.com",
  evervaultProductionUrl: "https://embedded-wallet.app-907329d19a06.enclave.evervault.com",
  passkeysManagementUrl: `https://${EMBEDDED_WALLET_HOSTNAME}/manage/passkey`,
  // API Paths
  trmPath: "/v1/screen",
  gasServicePath: "/v1/gas-fee",
  tradingApiPaths: {
    quote: `${tradingApiVersionPrefix}/quote`,
    indicativeQuote: `${tradingApiVersionPrefix}/indicative_quote`,
    approval: `${tradingApiVersionPrefix}/check_approval`,
    swap: `${tradingApiVersionPrefix}/swap`,
    swap5792: `${tradingApiVersionPrefix}/swap_5792`,
    order: `${tradingApiVersionPrefix}/order`,
    orders: `${tradingApiVersionPrefix}/orders`,
    swaps: `${tradingApiVersionPrefix}/swaps`,
    swappableTokens: `${tradingApiVersionPrefix}/swappable_tokens`,
    createLp: `${tradingApiVersionPrefix}/lp/create`,
    increaseLp: `${tradingApiVersionPrefix}/lp/increase`,
    decreaseLp: `${tradingApiVersionPrefix}/lp/decrease`,
    claimLpFees: `${tradingApiVersionPrefix}/lp/claim`,
    lpApproval: `${tradingApiVersionPrefix}/lp/approve`,
    migrate: `${tradingApiVersionPrefix}/lp/migrate`,
    claimRewards: `${tradingApiVersionPrefix}/lp/claim_rewards`,
    wallet: {
      checkDelegation: `${tradingApiVersionPrefix}/wallet/check_delegation`,
      encode7702: `${tradingApiVersionPrefix}/wallet/encode_7702`
    },
    swap7702: `${tradingApiVersionPrefix}/swap_7702`
  },
  // App and Redirect URL's
  appBaseUrl: UNISWAP_APP_URL,
  redirectUrlBase: UNISWAP_MOBILE_REDIRECT_URL,
  requestOriginUrl: UNISWAP_WEB_URL,
  // Web Interface Urls
  webInterfaceSwapUrl: `${UNISWAP_WEB_URL}/#/swap`,
  webInterfaceTokensUrl: `${UNISWAP_WEB_URL}/explore/tokens`,
  webInterfaceAddressUrl: `${UNISWAP_WEB_URL}/address`,
  webInterfaceNftItemUrl: `${UNISWAP_WEB_URL}/nfts/asset`,
  webInterfaceNftCollectionUrl: `${UNISWAP_WEB_URL}/nfts/collection`,
  webInterfaceBuyUrl: `${UNISWAP_WEB_URL}/buy`,
  // Feedback Links
  walletFeedbackForm: "https://docs.google.com/forms/d/e/1FAIpQLSepzL5aMuSfRhSgw0zDw_gVmc2aeVevfrb1UbOwn6WGJ--46w/viewform",
  dataApiServiceUrl: `${getCloudflareApiBaseUrl()}/v2/data.v1.DataApiService`,
  dataApiServicePaths: {
    report: "/SubmitReport"
  }
};
function getCloudflarePrefix(flow) {
  if (flow && isDevOrBeta && FLOWS_USING_BETA.includes(flow)) {
    return `beta`;
  }
  if (isMobileApp) {
    return `${isAndroid ? "android" : "ios"}.wallet`;
  }
  if (isExtension) {
    return "extension";
  }
  if (isPlaywrightEnv() || isInterface) {
    return "interface";
  }
  if (isTestEnv()) {
    return "wallet";
  }
  throw new Error("Could not determine app to generate Cloudflare prefix");
}
function getServicePrefix(flow) {
  if (flow && (isPlaywrightEnv() || !(isDevOrBeta && FLOWS_USING_BETA.includes(flow)))) {
    return flow + ".";
  } else {
    return "";
  }
}
function getCloudflareApiBaseUrl(flow) {
  return `https://${getServicePrefix(flow)}${getCloudflarePrefix(flow)}.topazdex.com`;
}
